import { TemplateGroups } from "components/TemplateEditor/Components/SectionPicker/Contstants";
import {
  SECTIONS_CASE,
  SECTIONS_CREDITOR,
  SECTIONS_DEBTOR,
  SECTIONS_SUBCASE,
} from "constants/TemplateEditor";
import { PreviewDataPayload, TemplatePreviewPayload } from "interfaces";
import { httpCollection } from "us.helper/http/collection";

export default {
  parameterList: {
    get: (params: number[]): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationdata",
            "datasource/SQL/adapterdata",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  sections: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          // const { data, status } = await httpCollection.get(
          //   "communicationdata",
          //   "datasource/SQL/1",
          //   {}
          // );
          switch (params.groupName) {
            case TemplateGroups.CASE:
              resolve({ data: SECTIONS_CASE, status: 200 });
              break;
            case TemplateGroups.SUBCASE:
              resolve({ data: SECTIONS_SUBCASE, status: 200 });
              break;
            case TemplateGroups.CREDITOR:
              resolve({ data: SECTIONS_CREDITOR, status: 200 });
              break;
            case TemplateGroups.DEBTOR:
              resolve({ data: SECTIONS_DEBTOR, status: 200 });
              break;
            default:
              resolve({ data: SECTIONS_SUBCASE, status: 200 });
              break;
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  adapters: {
    byCategoryId: ({
      categoryId,
      isRepeating,
      groupId,
    }: {
      categoryId: number;
      isRepeating: boolean;
      groupId: number;
    }): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            `adapters`,
            {
              categoryid: categoryId,
              isrepeating: isRepeating,
              groupId: groupId,
            }
          );
          resolve({
            data,
            status,
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  template: {
    getRules: ({ templateId }: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            `template/${templateId}/rule`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    saveRule: ({ templateId, saveParams }: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const saveData = await httpCollection.post(
            "communicationservice",
            `template/rule`,
            saveParams
          );
          const rules = await httpCollection.get(
            "communicationservice",
            `template/${templateId}/rule`,
            {}
          );
          resolve({
            rulesData: rules.data,
            rulesStatus: rules.status,
            saveStatus: saveData.status,
          });
        } catch (error) {
          reject(error);
        }
      });
    },
    getPreview: (payload: TemplatePreviewPayload): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationservice",
            `template/preview`,
            payload
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  previewData: {
    get: (params: PreviewDataPayload): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationdata",
            "datasource/SQL/previewdata",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  repeatingAdapters: {
    get: (params: PreviewDataPayload): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            `adapters`,
            {
              categoryid: 1,
              isrepeating: false,
            }
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
